//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import ReactExport from "react-data-export";
import * as moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default function DeactivationSummaryReportXLSX({ states, date, page, reportId }) {
  const { excelData } = states;
  // let transactions1 = excelData?.ciprian?.map((t) =>Object.entries(t).map((obj)=>{console.log(obj,)}))

  let transactions = excelData?.ciprian?.map((t) =>Object.entries(t).map((obj)=>{return{value:obj[1] !=null?obj[1]+ String.fromCharCode(8203).toLocaleString('en-US'):" ",style: {alignment: { horizontal: "center" } }}}))
  // console.log(transactions,"excelData")
  let headings = excelData?.ciprian ?excelData?.ciprian[0]:{"title":"title"}

  let headerEnrollStyles = {
    font: { bold: true, color: { rgb: "00000000" } },
  };
  let headerEnrollStyles1 = {
    font: { bold: false, color: { rgb: "00000000" } },
  };

  let borderStyles = {
    border: {
      top: { style: "thin", color: { rgb: "00000000" } },
      bottom: { style: "thin", color: { rgb: "00000000" } },
      left: { style: "thin", color: { rgb: "00000000" } },
      right: { style: "thin", color: { rgb: "00000000" } },
    },
  };

  let header1Styles = {
    style: {
      font: { bold: true },
    },
  };
  
  let coulumns =Object.entries(headings).map((obj)=>{return{value:obj[0]?obj[0]:"", style: { ...headerEnrollStyles,alignment: { horizontal: "center" } }}})
// console.log(coulumns,"coulumn")
 
  const multiDataSet = [
    {
      columns: [
        { title: "Report Date", width: { wch: 17 },style: { ...headerEnrollStyles } },
        { title: moment().format("MM/DD/YYYY"),style: { ...headerEnrollStyles1 }},
        { title: "", width: { wch: 29 } },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 20 } },
        { title: "", width: { wch: 20 } },
        { title: "", width: { wch: 20 } },
        { title: "", width: { wch: 20 } },
        { title: "", width: { wch: 20 } },

      ],
      data: [
        [
          {
            value: "Date Range Pulled",
            ...header1Styles,
          },
          {
            value:date
          }
          
        ],
        coulumns||[],
        ...(transactions || []),
      ],
    },
  ]

  return (
    <ExcelFile
      filename={`${page}`+"-"+moment(new Date()).format("YYYYMMDD")}
      element={
        <button id="csv" style={{ display: "none" }}>
          Hidden btn
        </button>
      }
    >
      <ExcelSheet dataSet={multiDataSet} name="Deactivated Report" />
    </ExcelFile>
  );

}
